import { HttpClient } from "@/shared/lib/http-client"
import { env } from "@/config/env"
import type { ConfigDTO } from "./config.dto"
import type { AppConfig, ConfigParams } from "../types"

export interface IConfigService {
  readonly isConfigured: boolean
  fetchConfig(id: string): Promise<AppConfig>
}

function normalizeParams(raw: ConfigDTO["params"]): ConfigParams {
  const out: ConfigParams = {}
  if (!raw) return out
  for (const [key, value] of Object.entries(raw)) {
    if (value !== null && value !== undefined) out[key] = String(value)
  }
  return out
}

/**
 * Fetches a funnel config by id: GET {base}/{id} -> { url?, params }.
 */
export class ConfigService extends HttpClient implements IConfigService {
  readonly isConfigured: boolean

  constructor(baseURL: string) {
    super({ baseURL })
    this.isConfigured = Boolean(baseURL)
  }

  async fetchConfig(id: string): Promise<AppConfig> {
    const dto = await this.get<ConfigDTO>(`/${encodeURIComponent(id)}`)
    return {
      id,
      url: dto?.url ?? null,
      params: normalizeParams(dto?.params),
    }
  }
}

export const configService: IConfigService = new ConfigService(env.VITE_CONFIG_API_URL)
